// extracted by mini-css-extract-plugin
export default {"logTitle":"Logs_logTitle__aTwlm"};